// Shapes rate card lines into the exact payload updateRateCard expects. Shared by the rate
// card editor's autosave so server-side validation receives a predictable line structure.
export function sanitizeLines(lines) {
    return (lines || []).map(sanitizeLine)
}

function sanitizeLine({
    tradeId,
    hourlyRate,
    minimumBillingPeriod,
    notes,
    mode,
    fixedAnnualAmount,
    contractedDaysPerYear,
    skillOverrides,
}) {
    return {
        tradeId,
        hourlyRate: hourlyRate || 0,
        minimumBillingPeriod: validateMinBillingPeriod(minimumBillingPeriod),
        notes: notes || "",
        mode: mode || "hourly",
        fixedAnnualAmount: fixedAnnualAmount ?? null,
        contractedDaysPerYear: contractedDaysPerYear ?? null,
        skillOverrides: (skillOverrides || []).map(sanitizeSkillOverride),
    }
}

function sanitizeSkillOverride(override) {
    return { skillId: override.skillId, hourlyRate: override.hourlyRate }
}

function validateMinBillingPeriod(value) {
    if (value == null) return null
    const parsed = typeof value === "string" ? Number(value.trim()) : value
    if (typeof parsed === "number" && Number.isInteger(parsed) && parsed > 0) return parsed
    return null
}
